export { default as AlphaTemplate } from './AlphaTemplate/AlphaTemplate';
export { default as BetaTemplate } from './BetaTemplate/BetaTemplate';
